var e = {
	title: "Reports",
	range: {
		label: "Period",
		last30: "Last 30 days",
		last90: "Last 90 days",
		ytd: "Year to date",
		custom: "Custom",
		from: "From",
		to: "To",
		apply: "Apply"
	},
	groupByLabel: "Group by",
	reportLabel: "Report",
	asOf: "Figures to {{date}}",
	kpis: {
		noValue: "—",
		otherCurrencies: "Revenue in {{currency}} only. Also earned in {{others}}."
	},
	unpriced_one: "{{count}} night has no price recorded and is left out of revenue.",
	unpriced_other: "{{count}} nights have no price recorded and are left out of revenue.",
	chart: { empty: "No data for this period" },
	table: {
		period: "Period",
		roomType: "Room type",
		ratePlan: "Rate plan",
		room: "Room",
		currency: "Currency",
		allRoomTypes: "All room types",
		lastYear: "Same time last year",
		change: "Change",
		cancellations: "Cancellations"
	},
	export: {
		csv: "Download CSV",
		savedAs: "Saved as {{filename}}"
	},
	empty: {
		title: "No stays in this period",
		body: "Pick a longer period, or come back once guests have stayed."
	},
	error: {
		title: "We couldn't load the report",
		unavailable: "Reports are briefly unavailable. Try again in a moment.",
		retry: "Try again"
	}
};
//#endregion
export { e as default };
